import React from "react";


class TaskEmail extends React.Component {
    render() {
        return (
            <div className="dashboard-widgets px-2 pt-2">
                <div >

                    <div style={{ display: 'flex', flexDirection: 'column', }}>
                        <div className="flexcb">
                            <div className='flexc'>
                                <div style={{ width: 45 }} className='' >
                                    <img className='w-100 br-50' src='/images/male.png' alt="" style={{ border: '1px solid #fff' }} />
                                    {/* <div className='w-100 br-50' style={{ background: '#ee5050', border: '2px solid #fff' }} /> */}
                                </div>
                                <div className='pld-3' >
                                    <p>
                                        Zain Ekstrom Bothman
                                    </p>
                                    <p style={{ color: '#ADADAD', fontSize: 11 }}>examplemail@yonnect.com</p>
                                </div>
                            </div>
                            <div>
                                <p>21 June 2021</p>
                            </div>
                        </div>
                        <div style={{ borderBottom: '1px solid #F4F5F8', margin: '9px 0ّ' }} />
                        <div className="d-flex flex-column">

                            <p className="pt-2" style={{ color: '#A7A7A7', fontWeight: 900, fontSize: 14 }}>
                                Title :
                            </p>
                            <p className="pt-1" style={{ color: '#262626', fontSize: 14 }}>
                                Vulputate ut accumsan, urna odio sit.
                            </p>
                        </div>
                    </div>

                    <div style={{}} className="  p-2">
                        <p className="pb-1" style={{ color: '#A7A7A7', fontWeight: 900, fontSize: 14 }}>
                            Message :
                        </p>
                        <div className="d-flex align-items-center">
                            <p className="" style={{ fontSize: 14, color: '#626262' }}>
                                In ipsum risus, eu in sed sem facilisis eget. Nisl volutpat, sagittis aliquet ornare cursus leo. Risus, ut nec amet, aliquam adipiscing. Purus amet bibendum nulla vitae erat gravida dictum habitant at. Et euismod adipiscing dignissim lacinia amet ipsum pellentesque potenti semper.                            </p>
                        </div>
                    </div>
                    <div className="d-flex w-100 p-2 ">
                        <div style={{ borderRadius: 50, width: 45, height: 45, background: '#E6F0FF', padding: 10 }} className='flex-4 mrd-3'>

                            <div style={{ width: 25, height: 25 }}>

                                <img width={'100%'} src='/images/icons/sr-bell.png' alt="" />
                            </div>
                        </div>
                        <div style={{ borderRadius: 50, padding: '7px 20px', background: '#0085FF', alignItems: 'center', display: 'flex', justifyContent: 'center' }} className="flex-1 p-2">
                            {/* <div style={{ width: 45, height: 45 }}>
                                <img width={'100%'} src='/images/replay.png' alt="" />
                            </div> */}
                            <div>
                                <p style={{ color: '#fff', textAlign: 'center' }}>

                                    Replay
                                </p>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        )
    }
}


export default TaskEmail;